export const europe = [
  ['Deutschland', 51.3150233,8.0467253],
  ['Frankreich', 46.5389377,0.3765643],                   
  ['Italien', 42.3547184,12.2594965],                                                                    
  ['Lettland', 56.8600938,22.3021486],                        
  ['Finnland', 62.1549625,24.5412633],                                              
  ['Spanien', 40.0733242,-4.2758607],                       
  ['Polen', 51.9032083,20.0680263],                          
  ['Schweden', 64.7029613,15.0865803],                                             
  ['Großbritannien', 57.1322949,-3.7037157],  
  ['Zypern', 37.010411, 31.494373], 
  ['Malta', 35.5681943,14.1311833], 
  ['Slowakei', 48.667044,18.5785805],  
  ['Rumänien', 45.919963,22.7775614]
];

export const germany = [
  ['Baden-Württemberg', 48.832237, 8.602314],
  ['Bayern', 48.9468951, 11.4232202],
  ['Berlin', 52.5327, 13.368151],
  ['Brandenburg',52.147052, 13.029619],
  ['Bremen', 53.112144339, 8.78623450],
  ['Hamburg', 53.554568183, 10.027208746],
  ['Hessen', 50.804256, 8.659773],
  ['Mecklenburg-Vorpommern', 53.7531202, 12.53758385],
  ['Niedersachsen', 52.661918, 9.468131],
  ['Nordrhein-Westfalen', 51.496297, 7.219533],
  ['Rheinland-Pfalz', 50.179671, 6.654691],
  ['Saarland',49.386627, 6.9570273],
  ['Sachsen-Anhalt', 51.843087, 11.056544],
  ['Sachsen', 51.155872, 13.303364],
  ['Schleswig-Holstein', 54.261276, 9.109166],
  ['Thüringen', 50.9029749, 11.0304845]
];

export default {
  europe,
  germany
}